/* eslint-disable no-undef */
import { DEFAULT_HOSTNAME } from 'config/hostnames';
import { getUserMetadata } from './UserServiceAPIUtils';

const METADATA_USER_TYPES = ['Admin', 'Shipper', 'Carrier'];

const _getAccountId = (user) => {
  if (user._type === 'Shipper') {
    return user && user.master_account ? user.master_account.id : user._id;
  }
  return user._id;
};

const _getUserCompany = (user) => {
  if (user._type === 'Shipper') {
    return user.company_name;
  }
  if (user._type === 'Carrier') {
    return user.company;
  }
  return 'Cargomatic';
};

const initializeIntercom = async (user) => {
  const { _type, _id } = user;
  if (METADATA_USER_TYPES.includes(_type)) {
    const userResponse = await getUserMetadata(_id);
    if (userResponse.errors) {
      console.log('Error fetching metadata', userResponse.errors);
      return null;
    }
    const metadata = userResponse.data.getUser;
    if (Intercom && metadata) {
      Intercom('boot', {
        app_id: 'm6biruzh',
        email: metadata.email,
        created_at: metadata.createdAt,
        name: metadata.name,
        user_id: metadata.legacyUserId,
        user_type: metadata.userType,
        user_hash: metadata.hashedId,
      });
    }
  }
};

const shutdownIntercom = () => {
  Intercom('shutdown');
};

export { initializeIntercom, shutdownIntercom };
